export const PATH_PARAMETERS_GLOBAL_DEVICE_CONFIGURATION =
  "/parameters/device-configuration";

export const CUSTOM_VALUE = Number.MAX_VALUE;

export const AUTOMATIC_RENEWAL_DELAY_MIN = 1;
export const AUTOMATIC_RENEWAL_DELAY_MAX = 1098;

export const POLLING_FREQUENCY_MIN = 5;
export const POLLING_FREQUENCY_MAX = 1440;
